/**
 * 曳引驱动杂物电梯附表配置
 * 列索引 0-based，提交时 dataKey 后缀为 colIndex + 1
 */

function createEmptyValues (rowKeys) {
  const values = {};
  (rowKeys || []).forEach(key => {
    values[key] = '';
  });
  return values;
}

function createColumns (count, rowKeys) {
  return Array.from({ length: count }, (_, i) => ({
    id: `col-${i}`,
    values: createEmptyValues(rowKeys)
  }));
}

function getRowKeys (rows) {
  return (rows || []).map(row => row.key);
}

/** 附表 A3.2.5.1：层门间隙（45列） */
export function createGapTable () {
  const rows = [
    { label: '检查的门编号', key: 'doorNo', prefix: 'F' },
    { label: '门扇与门扇', key: 'doorToDoor', prefix: 'DR' },
    { label: '门扇与立柱', key: 'doorToColumn', prefix: 'ZR' },
    { label: '门扇与门楣', key: 'doorToLintel', prefix: 'MR' },
    { label: '门扇与门坎', key: 'doorToSill', prefix: 'KR' },
    { label: '施外力门扇与门扇', key: 'externalForce', prefix: 'WR' }
  ];
  return {
    columnCount: 45,
    columns: createColumns(45, getRowKeys(rows)),
    rows
  };
}

/** 附表 A3.2.5.4：自动关闭层门装置（15列） */
export function createAutoCloseTable () {
  const rows = [
    // { label: '检查的门编号', key: 'doorNo', prefix: 'L' },
    { label: '层门无自动关闭装置', key: 'noAutoClose', prefix: 'W' },
    { label: '层门自动关闭装置失效', key: 'autoCloseInvalid', prefix: 'ZDSX' }
  ];
  return {
    columnCount: 15,
    columns: createColumns(15, getRowKeys(rows)),
    rows
  };
}

/** 附表 A3.2.5.5：紧急开锁（15列） */
export function createEmergencyUnlockTable () {
  const rows = [
    // { label: '检查的门编号', key: 'doorNo', prefix: 'R' },
    { label: '层门无紧急开锁装置', key: 'noEmergencyUnlock', prefix: 'WJJ' },
    { label: '层门紧急开锁装置不能可靠开启', key: 'unlockUnreliable', prefix: 'BNKQ' },
    { label: '层门闭合时紧急开锁装置仍保持开锁位置', key: 'unlockStillOpen', prefix: 'BCKS' }
  ];
  return {
    columnCount: 15,
    columns: createColumns(15, getRowKeys(rows)),
    rows
  };
}

/** 附表 A3.2.5.6(1)：门的锁紧与闭合（15列） */
export function createDoorLockTable () {
  const rows = [
    // { label: '检查的门编号', key: 'doorNo', prefix: 'U' },
    { label: '未设置门锁装置', key: 'noLock', prefix: 'S' },
    { label: '锁紧动作不由重力、永久磁铁或弹簧产生和保持', key: 'lockNotByGravity', prefix: 'SJ' },
    { label: '锁紧动作不能保持', key: 'lockNotHold', prefix: 'B' },
    { label: '保持锁紧的元件失效后重力可导致开锁', key: 'gravityUnlock', prefix: 'SJSX' },
    { label: '层门门锁装置失效', key: 'lockInvalid', prefix: 'C' }
  ];
  return {
    columnCount: 15,
    columns: createColumns(15, getRowKeys(rows)),
    rows
  };
}

/** 附表 A3.2.5.6(2)：证实层门锁紧状态的电气安全装置（15列） */
export function createLockVerifyTable () {
  const rows = [
    { label: '检查的门编号', key: 'doorNo', prefix: 'O' },
    { label: '未设检查层门锁紧状态的电气安全装置', key: 'noElectricalLock', prefix: 'D' },
    { label: '检查层门锁紧状态的电气安全装置失效', key: 'electricalLockInvalid', prefix: 'Q' }
  ];
  return {
    columnCount: 15,
    columns: createColumns(15, getRowKeys(rows)),
    rows
  };
}

/** 附表 A3.2.5.7：层站标识（15列） */
export function createStationSignTable () {
  const rows = [
    { label: '检查的门编号', key: 'doorNo', prefix: 'I' },
    { label: '层门或附近无载重量标识', key: 'noLoadSign', prefix: 'SR' },
    { label: '无"禁止进入轿厢"标志', key: 'noWarningSign', prefix: 'SE' }
  ];
  return {
    columnCount: 15,
    columns: createColumns(15, getRowKeys(rows)),
    rows
  };
}

/** 附表 A3.3.6：运行试验（15列） */
export function createRunTestTable () {
  const rows = [
    { label: '检查的门编号', key: 'doorNo', prefix: 'H' },
    { label: '呼梯显示不正常', key: 'callDisplayBad', prefix: 'M' },
    { label: '楼层显示不正常', key: 'floorDisplayBad', prefix: 'E' },
    { label: '轿厢平层误差大', key: 'levelingError', prefix: 'T' }
  ];
  return {
    columnCount: 15,
    columns: createColumns(15, getRowKeys(rows)),
    rows
  };
}

export const GOODS_ELEVATOR_ATTACHMENT_TITLES = {
  table1: '附表 A3.2.5.1：层门间隙检测记录表(单位为mm)',
  table2: 'A3.2.5.4 自动关闭层门装置检查记录表',
  table3: 'A3.2.5.5 紧急开锁检查记录表',
  table4: '附表 A3.2.5.6(1) 门的锁紧与闭合检查记录表',
  table5: '附表 A3.2.5.6(2) 证实层门锁紧状态的电气安全装置检查记录表',
  table6: '附表 A3.2.5.7 层站标识检测记录表',
  table7: '附表 A3.3.6 运行试验记录表'
};

/** 附表与检验项映射（用于 infoList 详见附表） */
export const GOODS_ELEVATOR_FLOOR_APPENDIX_MAP = {
  CheckFloor1: { appendixText: 'A3.2.5.1', leafCode: 'A3.2.5.1.1' },
  CheckFloor2: { appendixText: 'A3.2.5.4', leafCode: 'A3.2.5.4.1' },
  CheckFloor3: { appendixText: 'A3.2.5.5', leafCode: 'A3.2.5.5.1' },
  CheckFloor4: { appendixText: 'A3.2.5.6(1)', leafCode: 'A3.2.5.6.1' },
  CheckFloor5: { appendixText: 'A3.2.5.6(2)', leafCode: 'A3.2.5.6.2' },
  CheckFloor6: { appendixText: 'A3.2.5.7', leafCode: 'A3.2.5.7.1' },
  CheckFloor7: { appendixText: 'A3.3.6', leafCode: 'A3.3.6.1.1' }
};

/** 从附表配置序列化 datas */
export function serializeGoodsElevatorTable (tableConfig, checkFloorNum) {
  const datas = [];
  if (!tableConfig || !Array.isArray(tableConfig.rows)) return datas;

  let hasData = false;
  tableConfig.rows.forEach(row => {
    const prefix = row.submitPrefix || row.prefix;
    if (!prefix) return;
    tableConfig.columns.forEach((col, colIndex) => {
      const val = col.values[row.key];
      if (val !== undefined && val !== null && String(val).trim() !== '') {
        hasData = true;
        datas.push({
          dataKey: `${prefix}${colIndex + 1}`,
          dataValue: String(val).trim()
        });
      }
    });
  });

  if (hasData && checkFloorNum) {
    const doorNos = tableConfig.columns
      .map(col => String((col.values && col.values.doorNo) || '').trim())
      .filter(Boolean)
      .join('/');
    if (doorNos) {
      datas.push({ dataKey: `CheckFloor${checkFloorNum}`, dataValue: doorNos });
    }
  }
  return datas;
}

/** 解析 dataKey 对应的附表单元格位置（不写入数据） */
export function resolveGoodsElevatorTableCell (tableConfig, dataKey) {
  if (!tableConfig || !dataKey) return null;
  const rows = [...(tableConfig.rows || [])].sort((a, b) => {
    const pa = (a.submitPrefix || a.prefix || '').length;
    const pb = (b.submitPrefix || b.prefix || '').length;
    return pb - pa;
  });
  for (const row of rows) {
    const prefix = row.submitPrefix || row.prefix;
    if (!prefix || !dataKey.startsWith(prefix)) continue;
    const colNum = parseInt(dataKey.slice(prefix.length), 10);
    if (isNaN(colNum) || colNum < 1 || colNum > tableConfig.columnCount) continue;
    return {
      colIndex: colNum - 1,
      rowKey: row.key
    };
  }
  return null;
}

/** 反填附表单元格（返回解析结果，由组件内 $set 写入以保证响应式） */
export function fillGoodsElevatorTableCell (tableConfig, dataKey, dataValue) {
  const resolved = resolveGoodsElevatorTableCell(tableConfig, dataKey);
  if (!resolved) return false;
  const col = tableConfig.columns[resolved.colIndex];
  if (!col) return false;
  if (!col.values) col.values = {};
  const normalized = dataValue == null ? '' : String(dataValue);
  col.values[resolved.rowKey] = normalized;
  return true;
}

/** 判断 dataKey 是否属于杂物梯附表 */
export function isGoodsElevatorPageTwoDataKey (dataKey) {
  if (!dataKey || typeof dataKey !== 'string') return false;
  if (dataKey.startsWith('CheckFloor')) return true;
  const prefixes = [
    'ZDSX', 'BNKQ', 'BCKS', 'WJJ', 'SJSX',
    'CheckFloor',
    'DR', 'ZR', 'MR', 'KR', 'WR',
    'F', 'L', 'W', 'R', 'U', 'S', 'SJ', 'B', 'C',
    'O', 'D', 'Q', 'I', 'SR', 'SE',
    'H', 'M', 'E', 'T'
  ];
  return prefixes.some(p => {
    if (p === 'CheckFloor') return dataKey.startsWith('CheckFloor');
    if (!dataKey.startsWith(p)) return false;
    const num = dataKey.slice(p.length);
    return /^\d+$/.test(num);
  });
}
